'use client';

import { ConversationChatPanel } from './ConversationChatPanel';
import { useChatScene } from './use-chat-scene';
import { WelcomeChatPanel } from './WelcomeChatPanel';

/**
 * Chat 顶层场景分发：
 *
 * - `useChatScene` 集中托管 messages / stream / store / dropzone / handlers，
 *   保证欢迎态首条消息发送后切到对话态时，state 不会因为子组件 unmount 而中断。
 * - 真正的 JSX 由 WelcomeChatPanel / ConversationChatPanel 按场景渲染。
 *
 * 详见同目录 PRD：docs/exec-plans/active/vidu-next-claw-input-refactor-prd.md
 */
export const Chat = ({ sessionsId }: { sessionsId?: string }) => {
  const ctx = useChatScene({ sessionsId });

  return ctx.isNew ? <WelcomeChatPanel ctx={ctx} /> : <ConversationChatPanel ctx={ctx} />;
};
